import {
  CREATE_SUBTASK,
  DELETE_JOB,
  DELETE_SUBTASK,
  EXPORT_JOB_REPORT,
  GET_JOBS_LIST,
  GET_JOBS_SHORT_LIST,
  GET_JOB_DETAILS,
  GET_SUBTASKS,
  JOB_ASSIGNEE_ADD,
  JOB_ASSIGNEE_REMOVE,
  RESET_SUBTASK_STATUS,
  UPDATE_JOB_STATUS,
  UPDATE_SUBTASK,
  GET_JOB_DOCUMENTS_LIST,
  CREATE_JOB_DOCUMENT,
  DELETE_JOB_DOCUMENT,
  GET_JOB_CONFLICT_LIST,
} from "../../modules/constants";

export function getSubtasks(value) {
  return {
    type: GET_SUBTASKS,
    payload: value,
  };
}

export function createSubtask(value) {
  return {
    type: CREATE_SUBTASK,
    payload: value,
  };
}

export function updateSubtask(value) {
  return {
    type: UPDATE_SUBTASK,
    payload: value,
  };
}

export function deleteSubtask(value) {
  return {
    type: DELETE_SUBTASK,
    payload: value,
  };
}

export function resetSubtaskStatus() {
  return {
    type: RESET_SUBTASK_STATUS,
  };
}


export function updateJobApproval(value) {
  return {
    type: UPDATE_JOB_STATUS,
    payload: value,
  };
}

export function getJobList(value) {
  return {
    type: GET_JOBS_LIST,
    payload: value,
  };
}

export function getjobsShortList(value) {
  return {
    type: GET_JOBS_SHORT_LIST,
    payload: value,
  };
}
export function getJobDetails(value) {
  return {
    type: GET_JOB_DETAILS,
    payload: value,
  };
}

export function getJobConflictList(value) {
  return {
    type: GET_JOB_CONFLICT_LIST,
    payload: value,
  };
}

export function removeJobAssignee(value) {
  return {
    type: JOB_ASSIGNEE_REMOVE,
    payload: value,
  };
}

export function addJobAssignee(value) {
  return {
    type: JOB_ASSIGNEE_ADD,
    payload: value,
  };
}

export function deleteJob(value) {
  return {
    type: DELETE_JOB,
    payload: value,
  };
}

export function exportJobReport(value) {
  return {
    type: EXPORT_JOB_REPORT,
    payload: value,
  };
}


// Documents Actions
export const createJobDocument = payload => ({
  type: CREATE_JOB_DOCUMENT,
  payload,
});

export const deleteJobDocument = payload => ({
  type: DELETE_JOB_DOCUMENT,
  payload,
});

export const getJobDocuments = payload => ({
  type: GET_JOB_DOCUMENTS_LIST,
  payload,
});